import { ActionTypes } from '../Actions/Actions';
import * as fromActions from '../Actions/Actions';
import { BoosterId } from './boosters';
import { TutorialActions } from '../../Config/Tutorial';

export interface ITutorialUpdatePayload {
    actionId: TutorialActions | null;
    payload?: string | null;
}

export interface IStateTutorial {
    index: number;
    match: string | null;
    matchPayload: string | null;
    tutorialBooster: BoosterId;
}

export const defaultStateTutorial: IStateTutorial = {
    index: -1,
    match: null,
    matchPayload: null,
    tutorialBooster: null,
};
export const StateTutorial = (
    state = defaultStateTutorial,
    action: fromActions.Actions
): IStateTutorial => {
    switch (action.type) {
        case ActionTypes.TUTORIAL_START:
            return {
                ...state,
                index: action.payload,
            };
        case ActionTypes.TUTORIAL_END:
            return {
                ...state,
                index: -1,
                tutorialBooster: null,
            };
        case ActionTypes.TUTORIAL_UPDATE:
            return {
                ...state,
                match: action.payload.actionId,
                matchPayload: action.payload.payload || null,
            };
        case ActionTypes.TUTORIAL_SET_BOOSTER:
            return {
                ...state,
                tutorialBooster: action.payload,
            };
        default:
            return state;
    }
};
